import { useContext } from "react";
import { SettingsContext } from "../providers/SettingsProvider";
import { timesheetsRef, quotesRef, jobsheetsRef } from "../firebase";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import { v4 as uuidv4 } from "uuid";
import { useHistory } from "react-router-dom";

import { defaultCustomer } from "../popData";
import { doc } from "firebase/firestore";
import { setPrimary } from "../helperFunctions/primaryWrites";

export const useAddPrimary = () => {
  // const defualtCusUid = defualtCustomerUid;
  const { currentTsNumber, currentQuoteNumber, currentJobsheetNumber, incCurrentPrimaryNumber, vat } =
    useContext(SettingsContext);

  const history = useHistory();

  return async function addPrimary(primaryType, userUid, injectedData = {}) {
    if (primaryType == null) {
      return { success: false, error: "Primary type not defined" };
    }
    let currentPrimaryNumber = null;
    let dbRef = null;

    if (primaryType === "timesheet") {
      currentPrimaryNumber = currentTsNumber;
      dbRef = timesheetsRef;
    }
    if (primaryType === "quote") {
      currentPrimaryNumber = currentQuoteNumber;
      dbRef = quotesRef;
    }
    if (primaryType === "jobsheet") {
      //currentPrimaryNumber = currentJobsheetNumber;
      currentPrimaryNumber = "";
      dbRef = jobsheetsRef;
    }

    //Created field in database can just be unformatted number, the default jobReceived
    //date however, is formatted making it easier to use on retreival.
    const todaysDate = Date.now();
    const currentDate = dateTimeFormatter(todaysDate, "d_full_variant");
    const createdDate = todaysDate;

    const primaryId = uuidv4();
    const blankPrimary = {
      uid: primaryId,
      refNumber: currentPrimaryNumber,
      jobReceived: currentDate,
      created: createdDate,
      createdBy: userUid,
      primaryType: primaryType,
      city: defaultCustomer.city,
      customerUid: defaultCustomer.uid,
      name: defaultCustomer.name,
      accessId: defaultCustomer.accessId,
      vatMode: vat,
      jobTypeCategory: "general",
      ...injectedData,
      // test: new Date(),
    };

    //Either here or down there. The problem with here is that an error pops up with firebase because
    //db fields are trying to be changed too quickly. The problem with down there is that there seems
    //to be a bit of lag which I hate. Ideal solution would be to use a loading bar of some kind.
    // history.push(`/${primaryType}/${primaryId}`, {
    //   [primaryType]: blankPrimary,
    // });

    try {
      await history.push(`/${primaryType}/${primaryId}`, {
        [primaryType]: blankPrimary,
      });

      await setPrimary(doc(dbRef, `${primaryId}`), blankPrimary);

      await incCurrentPrimaryNumber(primaryType);
    } catch (err) {
      console.log("Error", err);
      return { success: false, error: err };
    }

    return { success: true, error: null, uid: primaryId };
  };
};
